//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
let d=[[[0,"AlignmentType",1,0],[0,"Emphasize",1,0],[0,"FitMethod",1,0],[0,"Patch",1,0],[0,"UseSplinePoint",1,0],[0,"Vclose",1,0],[0,"Vdegree",1,0]],[[[],"Dispose",{},0,0]],[]];
SPLM.MeshParameterData = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MeshParameterData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MeshParameterData.FeatureType = Object.freeze({
    "CurveMesh" : "CurveMesh", "ThroughCurves" : "ThroughCurves", "Ruled" : "Ruled"});

SPLM.MeshParameterData.Type = Object.freeze({
    "Unused" : "Unused", "AlignedByParameter" : "AlignedByParameter", "AlignedByArclength" : "AlignedByArclength", "AlignedByDistance" : "AlignedByDistance", "AlignedByAngle" : "AlignedByAngle", "AlignedBySpine" : "AlignedBySpine", "AlignedByPoint" : "AlignedByPoint", "AlignedBySplinePt" : "AlignedBySplinePt", "AlignedBySegment" : "AlignedBySegment", "PatchBezier" : "PatchBezier", "PatchBspline" : "PatchBspline", "PatchClosedBspline" : "PatchClosedBspline", "PatchMatchString" : "PatchMatchString", "EmphasizePrimary" : "EmphasizePrimary", "EmphasizeCross" : "EmphasizeCross", "EmphasizeBoth" : "EmphasizeBoth", "FitExact" : "FitExact", "FitApproximate" : "FitApproximate", "VclosedOpen" : "VclosedOpen", "VclosedClose" : "VclosedClose"});

export default SPLM;